/*=========================================================================================
  File Name: moduleFonctionState.js
  Description: Fonction Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  fonctions: []
}
